import { differenceWith, intersectionWith } from "lodash/array";
import { isEqual } from "lodash/lang";
import constant from "./constant";

const getGateOutLoadingZoneDetails = ({ plannedBills, gateoutBills, zone }) => {
  const [plannedZoneBills, gateoutZoneBills] = [
    plannedBills.filter(bill => bill.loadingZone === zone),
    gateoutBills.filter(bill => bill.loadingZone === zone)
  ];
  const zoneData = {
    totalBills: gateoutZoneBills.length,
    missedBills: differenceWith(plannedZoneBills, gateoutZoneBills, isEqual).length,
    extraBills: differenceWith(gateoutZoneBills, plannedZoneBills, isEqual).length,
    matchedBills: intersectionWith(plannedZoneBills, gateoutZoneBills, isEqual).length,
    difference: gateoutZoneBills.length - plannedZoneBills.length,
    loadingZone: zone
  };
  return zoneData;
};

const getPlannedLoadingZoneDetails = (plannedBills, zone) => {
  const plannedZoneBills = plannedBills.filter(bill => bill.loadingZone === zone);
  return {
    totalBills: plannedZoneBills.length,
    missedBills: null,
    extraBills: null,
    matchedBills: null,
    difference: null,
    loadingZone: zone
  };
};

const sortByProType = (currentPro, nextPro) => {
  if (
    (nextPro.billType === constant.PRO_TYPE.MISSED &&
      currentPro.billType !== constant.PRO_TYPE.MISSED) ||
    (nextPro.billType === constant.PRO_TYPE.EXTRA &&
      currentPro.billType === constant.PRO_TYPE.MACTHED) ||
    (nextPro.billType !== constant.PRO_TYPE.MATCHED &&
      currentPro.billType === constant.PRO_TYPE.MATCHED)
  ) {
    return 1; //swap in order to show pros in the order Missed, extra, matched
  }
  return -1;
};

export {
  getGateOutLoadingZoneDetails,
  getPlannedLoadingZoneDetails,
  sortByProType
};
